import React, { useMemo } from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import './table.scss';
import GeneralSearch from './GeneralSearchComponent';
import Dropdown from './DropdownFilter';
import { IDropdown } from '../model';

const ListHeader: React.FC<{
    TopChipsComponent?: React.ReactNode;
    TopChipsActionComponent?: React.ReactNode;
    LowerChipsComponent?: React.ReactNode;
    setDisplayedData: any;
    mainContent: object[];
    showChips: boolean;
    handleChipClick: any;
    dropdownOptions?: IDropdown;
    dataRef: React.RefObject<object[]>;
    counterRef: React.RefObject<number>;
    HeaderSideComponent?: React.ReactNode;
    TitleComponent?: React.ReactNode;
    outsideHooks?: any;
    handleTopChipClick?: any;
    displaySearch?: boolean;
    displayTopActionsComponent?: boolean;
}> = ({
          TopChipsComponent,
          TopChipsActionComponent,
          LowerChipsComponent,
          setDisplayedData,
          showChips,
          dropdownOptions,
          dataRef,
          counterRef,
          handleChipClick,
          mainContent,
          HeaderSideComponent,
          TitleComponent,
          handleTopChipClick,
          outsideHooks,
                            displaySearch,displayTopActionsComponent

      }) => {
    const memoShowChips = useMemo(() => showChips, [showChips]);


    return (
        <Box
            sx={{
                position: 'sticky',
                top: 0,
                zIndex: 10,
                backgroundColor: 'white',
                display: 'flex',
                flexDirection: 'column',
                padding: '0px',
                gap: '8px',
                margin: '0px 15px'
            }}
        >
            {TitleComponent && (
                <Collapse
                    in={memoShowChips}
                    timeout={1500}
                    sx={{
                        transition: 'transform 0.4s ease-out, opacity 0.4s ease-out'
                    }}
                >
                    <TitleComponent setDisplayedData={setDisplayedData}  outsideHooks={outsideHooks}/>
                </Collapse>
            )}

            {TopChipsComponent && (
                <Collapse
                    in={memoShowChips}
                    timeout={1500}
                    sx={{
                        height: 'fit-content',
                        transition: 'transform 0.4s ease-out, opacity 0.4s ease-out'
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            gap: '0px',
                            overflowX: 'auto',
                            padding: '0px 8px 0px 8px',
                            borderRadius: '15px',
                            '&::-webkit-scrollbar': {
                                display: 'none'
                            },
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {TopChipsActionComponent && (
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                <TopChipsActionComponent outsideHooks={outsideHooks} />
                        </Box>
                        )}
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row'
                            }}
                        >
                            <TopChipsComponent mainContent={mainContent} setDisplayedData={setDisplayedData} onClick={handleTopChipClick} outsideHooks={outsideHooks} />
                        </Box>
                    </Box>
                </Collapse>
            )}

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '8px',
                    width: '100%',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                {displaySearch && (
                    <Box sx={{ flex: dropdownOptions ? 0.9 : 1 }}>
                    <GeneralSearch handleSearchChange={setDisplayedData} dataRef={dataRef} counterRef={counterRef} outsideHooks={outsideHooks}/>
                    </Box>
                )}
                {dropdownOptions && (
                    <Box sx={{ flex: 0.1 }}>
                        <Dropdown options={dropdownOptions} />
                    </Box>
                )}
                {HeaderSideComponent && (
                    <Box sx={{ flex: 0.1 }}>
                        <HeaderSideComponent mainContent={dataRef} setDisplayedData={setDisplayedData} outsideHooks={outsideHooks} />
                    </Box>
                )}
            </Box>
            {LowerChipsComponent && (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '95vw',
                        paddingBottom: '0px',
                        overflowX: 'auto',
                        '&::-webkit-scrollbar': {
                            display: 'none'
                        },
                        whiteSpace: 'nowrap'
                    }}
                >
                    <LowerChipsComponent mainContent={mainContent} setDisplayedData={setDisplayedData} onClick={handleChipClick} outsideHooks={outsideHooks} />
                </Box>
            )}
        </Box>
    );
};

export default ListHeader;
